<template>
    <v-select
        :value="group"
        @change="changeGroup"
        :items="group_items"
        item-text="group_name"
        item-value="group_id"
        :label="$t('group_name')"
        :disabled="this.station_code==undefined"
        :multiple="multiple"
        return-object
        outlined
        dense
        v-model="selectedItems"
    ></v-select>
</template>


<script>

    import config from '@/../config.js'
    import axios from 'axios';
    import Staff from '@/model/instance/Staff.js'

    export default {
        props: {station_code:[String, Number],have_group_0: {type: Boolean,required: false,default: true},multiple: {type: Boolean,required: false,default: false},init_selectedItems: {type: Array,required: false,default: () => []}},
        data: () => ({
            group : {},
            group_items : [],
            grouplist : [],
            group_selects : [],
            selectedItems : []
        }),
        mounted : function () {
            if(this.station_code!=undefined){
                this.reload()
            }
        },
        methods: {
            changeGroup(group){
                this.$emit('ongroup', group)
            },
            reload(){
                var que = this.$store.commit('addLoading')
                setTimeout(() => {
                    axios
                    .post(config.api.url.manage.appointment.manage.get_grouplist,{station_code:this.station_code},{headers: Staff.getTokenHeader()})
                    .then(response => {
                        this.$store.commit('finishLoading',que)
                        this.grouplist = response.data.grouplist
                        this.group_items = this.grouplist
                        if(this.have_group_0) this.group_items = [{group_name:this.$i18n.t('select_group_all'),group_id:0}].concat(this.group_items)                
                    
                        this.selectedItems = this.grouplist.filter(g=>this.init_selectedItems.includes(g.group_id))

                    })
                    .catch(error => {
                        this.$router.push({name:'Error',params:error}) 
                    })
                }, 1000);
            },
            filtergroup(available_groups){
                if(available_groups.length==0){
                    this.group_items = this.grouplist
                }else{
                    this.group_items = this.grouplist.filter(g=>available_groups.includes(g.group_id))
                }
                if(this.have_group_0) this.group_items = [{group_name:this.$i18n.t('select_group_all'),group_id:0}].concat(this.group_items)                
                    
            }
        }
    }
</script>